import Vue from "vue";
import VueI18n from "vue-i18n";

let translatedMessages;
Vue.use(VueI18n);

try {
  translatedMessages = require('./translations/messages.json');
} catch (e) {
  throw e.stackTrace;
}

export default new VueI18n({
  locale: 'en-GB',
  fallbackLocale: 'en-GB',
  messages: translatedMessages
});
